



































































































import Vue, { PropType } from "vue";

/* Components */
import StepDropdown from "@/components/StepDropdown/StepDropdown.vue";
import Dropdown from "@/components/Dropdown/Dropdown.vue";
import ItemsGrid from "@/components/ItemsGrid/ItemsGrid.vue";
import Form from "@/components/Form/Form.vue";
import Summary from "@/components/Summary/Summary.vue";
import Loader from "@/components/Loader/Loader.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import ThankYouPage from "@/components/ThankYouPage/ThankYouPage.vue";

/* Interfaces */
import { IStep } from "@/interfaces/IStep";
import { ISaddleType } from "@/interfaces/ISaddleType";
import { ISaddleElement } from "@/interfaces/ISaddleElement";
import { ISummaryDetails } from "@/interfaces/ISummaryDetails";
import { IParsedFormData } from "@/components/Form/interfaces/IParsedFormData";

export default Vue.extend({
  components: {
    StepDropdown,
    Dropdown,
    ItemsGrid,
    Form,
    Summary,
    Loader,
    Accordion,
    ThankYouPage,
  },
  props: {
    steps: {
      type: Array as PropType<IStep[]>,
      required: true,
    },
    saddleTypes: {
      type: Array as PropType<ISaddleType[]>,
      required: true,
    },
    saddleElements: {
      type: Array as PropType<ISaddleElement[]>,
      required: true,
    },
    summaryDetails: {
      type: Array as PropType<ISummaryDetails[]>,
      required: true,
    },
    loadingSaddleTypes: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    loadingSaddleElements: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    thankYouPageVisible: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },
  computed: {
    isStepOneValid(): boolean {
      return this.saddleTypes.some((s) => s.selected);
    },
    isStepTwoValid(): boolean {
      return (
        this.saddleElements.every((element) =>
          element.saddleVariants.some((variant) => variant.selected)
        ) && !!this.saddleElements.length
      );
    },
  },
  methods: {
    selectSaddleType(id: number): void {
      this.$emit("selectedSaddleType", id);
    },
    selectSaddleElementVariant(variantId: number, elementTitle: string): void {
      this.$emit("selectSaddleElementVariant", { variantId, elementTitle });
    },
    onSubmit(parsedFormData: IParsedFormData[]): void {
      this.$emit("onSubmit", parsedFormData);
    },
    extractSelectedVariantTitle(test: any): string {
      return test.find((v: any) => v.selected)?.title || "";
    },
  },
});
